import React from 'react'
import styles from './styles.module.css'
import { useDispatch, useSelector } from 'react-redux';
import { COUNTRY_NAMES } from '../../../constans/countries/countries';
import { PRIORITIES, removeCountryFromWishlistSync, updatePrioritySync } from '../reducer';
import { addCountryToVisitedWithSync } from '../../VisitedListComponent/reducer';

export const WishListContainer = ({ country, isShared = false }) => {
  
    const dispatch = useDispatch();
    const countryCode = COUNTRY_NAMES.indexOf(country?.name);
    const isMobile = window.innerWidth <= 768;
    const priority = useSelector((state) => {
        if (countryCode === -1) return null;
        return state.wishList?.priorities?.[countryCode] || null;
    });
    
    if (!country || !country.name || countryCode === -1) {
        return null;
    }
    
    function addToVisited () {
        dispatch(addCountryToVisitedWithSync(countryCode));
        dispatch(removeCountryFromWishlistSync(countryCode)); 
    }
    
    function updatePriority (newPriority) {
        if (priority === newPriority) {
            dispatch(updatePrioritySync(countryCode, null));
        } else {
            dispatch(updatePrioritySync(countryCode, newPriority));
        }
    }

    function getPriorityLabel () {
        switch(priority) {
            case PRIORITIES.MUST: return <div className={styles.priority_must_label}>⭐ Must</div>;
            case PRIORITIES.NEXT: return <div className={styles.priority_next_label}>🔥 Next Trip</div>;
            case PRIORITIES.LATER: return <div className={styles.priority_later_label}>💤 Later</div>;
            default: return null;
        }
    }
    
    return (
        <div className={styles.root}>
            <div className={styles.wishContainer}>
                {!isShared && (
                    <div className={styles.like}
                        onClick={() => dispatch(removeCountryFromWishlistSync(countryCode))}>
                        {'\u2665'}
                    </div>
                )}
                <div className={styles.center_container}>
                    <div className={styles.flag}>{country.flag}</div>
                    <div className={styles.name}>{country.name}</div>
                </div>
                {!isShared && (
                    <div className={styles.visited}
                        onClick={() => addToVisited()}
                        title='I have been here'>
                        ┼
                    </div>
                )}
                <div className={styles.priority_label}>{getPriorityLabel()}</div>
            </div>
            {!isShared && (
                <div className={styles.priority_selection}>
                    <span 
                        className={`${styles.priority_must} ${priority === PRIORITIES.MUST ? styles.active : ''}`}
                        onClick={() => updatePriority(PRIORITIES.MUST)}>
                        {isMobile ? (
                            <>
                                <span>⭐</span>
                                <span>Must</span>
                            </>
                            ) : ('⭐ Must')
                        }
                    </span>
                    <span 
                        className={`${styles.priority_next} ${priority === PRIORITIES.NEXT ? styles.active : ''}`}
                        onClick={() => updatePriority(PRIORITIES.NEXT)}>
                        {isMobile ? (
                            <>
                                <span>🔥</span>
                                <span>Next Trip</span>
                            </>
                            ) : ('🔥 Next Trip')
                        }
                    </span>
                    <span 
                        className={`${styles.priority_later} ${priority === PRIORITIES.LATER ? styles.active : ''}`}
                        onClick={() => updatePriority(PRIORITIES.LATER)}>
                        {isMobile ? (
                            <>
                                <span>💤</span>
                                <span>Later</span>
                            </>
                            ) : ('💤 Later')
                        }
                    </span>
                </div>
            )}
        </div>
    )
}